/**
 * In-sketch chrome: a back button, the sketch title, a live fps readout and a
 * place to surface load errors. Auto-hides its own pointer surface so taps fall
 * through to the canvas — only the back button is interactive.
 */
export class Overlay {
  private readonly el: HTMLElement;
  private readonly titleEl: HTMLElement;
  private readonly fpsEl: HTMLElement;
  private readonly errEl: HTMLElement;
  private fpsAccum = 0;

  constructor(root: HTMLElement, onHome: () => void) {
    this.el = document.createElement('div');
    this.el.className = 'overlay hidden';

    const back = document.createElement('button');
    back.className = 'overlay-back';
    back.type = 'button';
    back.textContent = '‹ menu';
    back.addEventListener('click', onHome);

    this.titleEl = document.createElement('span');
    this.titleEl.className = 'overlay-title';

    this.fpsEl = document.createElement('span');
    this.fpsEl.className = 'overlay-fps';

    this.errEl = document.createElement('div');
    this.errEl.className = 'overlay-error hidden';

    const bar = document.createElement('div');
    bar.className = 'overlay-bar';
    bar.append(back, this.titleEl, this.fpsEl);

    this.el.append(bar, this.errEl);
    root.appendChild(this.el);
  }

  show(title: string): void {
    this.titleEl.textContent = title;
    this.errEl.classList.add('hidden');
    this.el.classList.remove('hidden');
  }

  hide(): void {
    this.el.classList.add('hidden');
  }

  error(message: string): void {
    this.errEl.textContent = message;
    this.errEl.classList.remove('hidden');
  }

  update(fps: number): void {
    // Throttle DOM writes to ~3/sec.
    this.fpsAccum += 1;
    if (this.fpsAccum >= 20) {
      this.fpsAccum = 0;
      this.fpsEl.textContent = `${Math.round(fps)} fps`;
    }
  }
}
